import { ActionResult, Maybe } from '@varo/graphql-schema-types';
import IntentCaptureRadioCard, {
  IntentCaptureRadioCardProps,
} from 'features/believeFunding/components/IntentCaptureRadioCard';
import React, { useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Button from 'shared/components/vxl/Button/Button';
import TitleXLText from 'shared/components/vxl/typography/primary/title/TitleXLText';
import { isAndroid } from 'shared/constants/platform';
import theme from 'shared/styles/theme';

type handleActionButton = (action?: Maybe<ActionResult>) => void;

export interface IntentCaptureScreenProps {
  headlineText?: string;
  topPadding?: number;
  cards: IntentCaptureRadioCardProps[];
  handleAction: handleActionButton;
}

const IntentCaptureScreen = ({
  headlineText,
  topPadding,
  cards,
  handleAction,
}: IntentCaptureScreenProps) => {
  const { bottom, top } = useSafeAreaInsets();

  const paddingTop = topPadding ?? top;

  const [selectedCard, setSelectedCard] = useState<string>(cards[0].id);

  return (
    <View style={[styles.container, { paddingTop }]}>
      <ScrollView style={styles.scrollContainer}>
        {headlineText ? (
          <TitleXLText style={styles.headlineText}>{headlineText}</TitleXLText>
        ) : null}
        <View style={styles.radioCardsContainer}>
          {cards.map((card) => (
            <IntentCaptureRadioCard
              key={card.id}
              isSelected={card.id === selectedCard}
              labelText={card.labelText}
              illustration={card.illustration}
              onPress={() => {
                setSelectedCard(card.id);
              }}
              tag={card.tag}
              id={card.id}
            />
          ))}
        </View>
      </ScrollView>
      <View
        style={[
          styles.footerContainer,
          {
            paddingBottom: isAndroid
              ? bottom + theme.spacing.m
              : bottom + theme.spacing.l,
          },
        ]}
      >
        <Button
          label="Continue"
          onPress={() => {
            const selectedCardInfo = cards.find(
              (card) => card.id === selectedCard,
            );
            handleAction(selectedCardInfo?.action);
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    flexDirection: 'column',
    flexGrow: 1,
    zIndex: 1,
  },
  footerContainer: {
    borderTopColor: theme.color.border.primary,
    borderTopWidth: 1,
    padding: theme.spacing.m,
  },
  headlineText: { padding: theme.spacing.m, textAlign: 'left' },
  radioCardsContainer: {
    backgroundColor: theme.color.background.primary,
    gap: theme.spacing.m,
    padding: theme.spacing.m,
  },
  scrollContainer: {
    flex: 1,
  },
});

export default IntentCaptureScreen;
